// @flow
import React, { Component } from 'react';
import AccountSwitcher from 'app/common/react/components/growth/unauth/signup/AccountSwitcher/AccountSwitcher';
import AccountSwitcherLoginModal from 'app/common/react/components/AccountSwitcherLoginModal/AccountSwitcherLoginModal';
import CONTAINER_NAME from 'app/common/react/components/growth/unauth/lib/loggingContainerConstants';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import type { AuthViewer } from 'app/packages/pinterest-flow-types/viewer';
import type { BusinessUser } from 'app/common/lib/BusinessOwnershipUtils';
import withViewer from 'app/common/lib/react/withViewer';
import { Box } from 'gestalt';
import { compose } from 'redux';
import { initializeAccounts } from 'app/common/lib/MultipleAccountsUtils';
import withResource, { type Resource } from 'app/common/lib/react/withResource';

type State = {
  showLoginModal: boolean,
};

type Props = {
  businessUser: Resource<BusinessUser>,
  customTaglineText?: string,
  hideAccountSwitchValueProp?: boolean,
  onDismiss: Function,
  showAddAccount?: boolean,
  viewer: AuthViewer,
  enterProMode?: () => void,
};

class AccountSwitcherModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { showAddAccount } = this.props;

    this.state = {
      showLoginModal: !!showAddAccount,
    };
  }

  // On mounting, the user must be in Multiple Accounts experiments
  // So initialize the localStorage if needed
  componentDidMount = () => {
    initializeAccounts(this.props.viewer, this.props.businessUser.data);
  };

  showLogin = () => this.setState({ showLoginModal: true });

  hideLogin = () => this.setState({ showLoginModal: false });

  render() {
    const {
      customTaglineText,
      hideAccountSwitchValueProp,
      onDismiss,
      showAddAccount,
      viewer,
      enterProMode,
    } = this.props;

    return this.state.showLoginModal ? (
      <AccountSwitcherLoginModal
        container={CONTAINER_NAME.ACCOUNT_SWITCHER_MODAL}
        onClose={showAddAccount ? onDismiss : this.hideLogin}
        customTaglineText={customTaglineText}
        hideAccountSwitchValueProp={hideAccountSwitchValueProp}
      />
    ) : (
      <Box position="relative">
        <Modal
          accessibilityModalLabel={i18n._(
            'View, add, and switch logged in users',
            'modal which allows user to add and switch multiple accounts',
          )}
          size="sm"
          heading={i18n._(
            'Switch accounts',
            'Short title on modal that allows a user to switch between different Pinterest accounts',
          )}
          accessibilityCloseLabel={i18n._('Dismiss selection', 'Label for dismissing the modal')}
          onDismiss={onDismiss}
        >
          <AccountSwitcher
            container={CONTAINER_NAME.ACCOUNT_SWITCHER_MODAL}
            onNavigateButtonClick={() => onDismiss()}
            showLogin={this.showLogin}
            viewer={viewer}
            enterProMode={enterProMode}
          />
        </Modal>
      </Box>
    );
  }
}

export default compose(
  withViewer,
  withResource({
    name: 'UserResource',
    key: 'businessUser',
    options: ({ viewer }) => ({
      username: viewer.username,
      field_set_key: 'linked_partner',
    }),
  }),
)(AccountSwitcherModal);
